import {externalApiURL} from '@yandex-delivery/client-core/api/corp'
import {fetch as fetchBase} from '@yandex-delivery/core/utils/network'
import {addQuery} from '@yandex-delivery/utils'

import type {CreateDCAARepositoryArguments, DcaaRepository} from './types'

export function createDcaaRepository(params: CreateDCAARepositoryArguments): DcaaRepository {
  const {fetch = fetchBase} = params

  return {
    fetchClientRoleList() {
      throw new Error('Function "fetchClientRoleList" not implemented.')
    },
    fetchPaymentMethods(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery(externalApiURL('cargo/v1/corp/employee/payment-methods/list'), query),
        body,
      })
    },
    fetchFormOrder(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery(externalApiURL('phoenix/dcaa/v1/form/order'), query),
        body,
      })
    },
    fetchCreateAccepted() {
      throw new Error('Function not implemented.')
    },
    fetchOrderCallFromManager() {
      throw new Error('Function "fetchOrderCallFromManager" not implemented.')
    },
    fetchPaymentMethodActualState() {
      throw new Error('Function not implemented.')
    },
    fetchOffersCalculate(body, query) {
      return fetch({
        method: 'POST',
        url: addQuery(externalApiURL('phoenix/dcaa/cargo/v2/offers/calculate'), query),
        body,
      })
    },
    fetchPreOrderRetrieve(query) {
      return fetch({
        url: addQuery(externalApiURL('phoenix/dcaa/cargo/v1/pre-orders/retrieve'), query),
      })
    },
    fetchPenaltyComplaintGenerate() {
      throw new Error('Function "fetchPenaltyComplaintGenerate" not implemented.')
    },
    fetchCardDetails() {
      throw new Error('Function not implemented')
    },
    fetchClaimsBulkInfo() {
      throw new Error('Function not implemented')
    },
    fetchClaimsInfo() {
      throw new Error('Function not implemented')
    },
    fetchClaimDraftInfo() {
      throw new Error('Function not implemented')
    },
    fetchClaimsPerformerPhoto() {
      throw new Error('Function not implemented')
    },
    fetchClaimsPerformerPosition() {
      throw new Error('Function not implemented')
    },
    fetchDriverVoiceforwarding() {
      throw new Error('Function not implemented')
    },
    fetchClaimsSearch() {
      throw new Error('Function not implemented')
    },
    fetchClaimsStatusModel() {
      throw new Error('Function not implemented')
    },
    fetchClaimDraftStatusModel() {
      throw new Error('Function not implemented')
    },
    fetchClaimsSearchFilters() {
      throw new Error('Function not implemented')
    },
    fetchClaimsTrackingLinks() {
      throw new Error('Function not implemented')
    },
    fetchClaimsDocument() {
      throw new Error('Function not implemented')
    },
    fetchClaimsCancel() {
      throw new Error('Function not implemented')
    },
    fetchFeedbackSave() {
      throw new Error('Function not implemented')
    },
    fetchBatchCreateStatus() {
      throw new Error('Function not implemented')
    },
    fetchBatchCreateUpload() {
      throw new Error('Function not implemented')
    },
    fetchClaimsProofOfDeliveryInfo() {
      throw new Error('Function not implemented')
    },
    fetchUdpCustomerOrderList() {
      throw new Error('Function not implemented')
    },
    fetchUdpCustomerOrderDetails() {
      throw new Error('Function not implemented')
    },
    fetchUdpOrderRepeat() {
      throw new Error('Function not implemented')
    },
    fetchUdpOrderDraft() {
      throw new Error('Function not implemented')
    },
    fetchUdpOrderDraftDetails() {
      throw new Error('Function not implemented')
    },
    fetchUdpTrackDetails() {
      throw new Error('Function not implemented')
    },
    fetchUdpDraftTrackDetails() {
      throw new Error('Function not implemented')
    },
    fetchClaimsConfirmationCode() {
      throw new Error('Function not implemented')
    },
    fetchPerformerInfo() {
      throw new Error('Function not implemented')
    },
    fetchIntegrationClaimsCancel() {
      throw new Error('Function not implemented')
    },
    fetchRequestGetHandoverAct() {
      throw new Error('Function not implemented')
    },
    fetchRequestDatetimeOptions() {
      throw new Error('Function not implemented')
    },
    fetchRequestRedeliveryOptions() {
      throw new Error('Function not implemented')
    },
    fetchLocationDetect() {
      throw new Error('Function not implemented')
    },
    fetchPickupPointList() {
      throw new Error('Function not implemented')
    },
    fetchRequestEdit() {
      throw new Error('Function not implemented')
    },
    fetchIntegrationSettings() {
      throw new Error('Function not implemented')
    },
    fetchClaimsActive() {
      throw new Error('Function not implemented')
    },
    fetchDefaultCorpClientIds() {
      throw new Error('Function not implemented')
    },
    fetchClaimsAccept() {
      throw new Error('Function not implemented')
    },
    fetchClaimsApplyChangesRequest() {
      throw new Error('Function not implemented')
    },
    fetchChallengePass() {
      throw new Error('Function not implemented')
    },
    fetchUdpBoxesEdit() {
      throw new Error('Function not implemented')
    },
    fetchUdpCustomerOrderCancel() {
      throw new Error('Function not implemented')
    },
    fetchUdpCustomerOrderCancelStatus() {
      throw new Error('Function not implemented')
    },
    fetchClientOptionList() {
      throw new Error('Function not implemented')
    },
    editClientOption() {
      throw new Error('Function not implemented')
    },
    fetchLastClaims() {
      throw new Error('Function not implemented')
    },
    fetchWidgetClaims() {
      throw new Error('Function not implemented')
    },
    saveClaimDraft() {
      throw new Error('Function not implemented')
    },
    fetchClaimDraftRemove() {
      throw new Error('Function not implemented')
    },
    fetchClaimDraftAccept() {
      throw new Error('Function not implemented')
    },
    fetchNotificationsAgreementEdit() {
      throw new Error('Function not implemented')
    },
    fetchProvideDataToCrm() {
      throw new Error('Function not implemented')
    },
    fetchIntegrationOffersInfo() {
      throw new Error('Function not implemented')
    },
    fetchOffersCreate() {
      throw new Error('Function not implemented')
    },
    fetchIntegrationOffersConfirm() {
      throw new Error('Function not implemented')
    },
    fetchLocationFeatures() {
      throw new Error('Function not implemented')
    },
    fetchCustomDeliveryZonesFetch() {
      throw new Error('Function not implemented')
    },
    fetchCustomDeliveryZonesPointsValidate() {
      throw new Error('Function not implemented')
    },
    fetchEditOwnerOptions() {
      throw new Error('Function not implemented')
    },
    fetchTagList() {
      throw new Error('Function not implemented')
    },
    fetchPickupsCancel() {
      throw new Error('Function not implemented')
    },
    fetchPickupCalendarDisable() {
      throw new Error('Function not implemented')
    },
    fetchShipmentEstimate() {
      throw new Error('Function not implemented')
    },
    fetchPickupPointsList() {
      throw new Error('Function not implemented')
    },
    fetchPickupFind() {
      throw new Error('Function not implemented')
    },
    fetchActivePickups() {
      throw new Error('Function not implemented')
    },
    fetchCalcPrice() {
      throw new Error('Function not implemented')
    },
    fetchPickupOptions() {
      throw new Error('Function not implemented')
    },
    editPickup() {
      throw new Error('Function not implemented')
    },
    editCalendarPickup() {
      throw new Error('Function not implemented')
    },
    fetchPickupsCreate() {
      throw new Error('Function not implemented')
    },
    fetchActiveClaimsList() {
      throw new Error('Function not implemented')
    },
    fetchStoragePeriodEdit() {
      throw new Error('Function not implemented')
    },
  }
}
